import React from "react";
import { useReveal } from "../hooks/useReveal";

const SHOWS = [
  "The Oscars",
  "The Grammys",
  "The CMA Awards",
  "Jeopardy!",
  "Wheel of Fortune",
  "The Voice",
  "And many others",
];

export default function WhoParticipating() {
  const headRef = useReveal();
  const margolisRef = useReveal();
  return (
    <section
      id="who"
      data-testid="who-section"
      className="section relative bg-[#020305]"
    >
      <div className="container-x relative z-10">
        <div ref={headRef} className="reveal max-w-3xl mb-16">
          <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/55">
            / 07 — Participants
          </span>
          <h2
            className="kinetic mt-6"
            style={{ fontSize: "clamp(2.4rem, 6vw, 5.5rem)", lineHeight: 0.95 }}
          >
            <span className="gradient-text">WHO IS PARTICIPATING</span>
            <br />
            <span className="outline-text-blue">IN THE PROTOS 100?</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7 space-y-6 text-white/75 text-lg leading-relaxed">
            <p className="text-xl lg:text-2xl text-white font-light leading-snug">
              The Protos 100 is intentionally small and{" "}
              <span style={{ color: "var(--blue-bright)" }}>highly curated.</span>
            </p>
            <p>
              We are inviting thoughtful, high-performing individuals whose feedback
              we genuinely value. People who operate under pressure, think
              creatively, solve difficult problems, and understand the importance of
              focus, composure, and intentional performance.
            </p>
            <p>Many participants already rely on performance rituals such as:</p>

            <div className="flex flex-wrap gap-2">
              {[
                "Coffee",
                "Training",
                "Supplementation",
                "Deep work systems",
                "Meditation",
                "Creative routines",
              ].map((t, i) => (
                <span
                  key={i}
                  data-testid={`who-ritual-${i}`}
                  className="tag"
                >
                  {t}
                </span>
              ))}
            </div>

            <p
              className="border-l-2 pl-6 py-2 text-white text-xl font-light"
              style={{ borderColor: "var(--blue-bright)" }}
            >
              Protos is not designed to replace those rituals.
            </p>
            <p>
              It is being tested as something that may help people become more
              intentional, grounded, focused, and locked in during moments that
              matter.
            </p>
          </div>

          <div ref={margolisRef} className="reveal lg:col-span-5">
            <div className="card-dark p-8 lg:p-10 h-full relative overflow-hidden">
              {/* Studio / broadcast atmosphere */}
              <img
                src="/assets/studio-lights.jpg"
                alt=""
                aria-hidden
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-screen"
              />
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(2,3,5,0.55) 0%, rgba(2,3,5,0.88) 100%)",
                }}
              />
              <div
                className="absolute inset-0 pointer-events-none mix-blend-overlay opacity-60"
                style={{
                  background:
                    "radial-gradient(circle at 80% 20%, rgba(31,179,255,0.35), transparent 60%)",
                }}
              />

              <div className="relative z-10">
              <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/55 mb-5">
                Early participants
              </div>
              <h3 className="font-display text-3xl lg:text-4xl uppercase text-white leading-tight">
                Peter &amp; <br />Lucinda Margolis
              </h3>
              <p className="mt-4 text-white/65 text-sm lg:text-base leading-relaxed">
                Renowned creative producers and directors behind some of the world's most
                recognizable live broadcasts and television productions, including:
              </p>

              <ul className="mt-6 space-y-2">
                {SHOWS.map((s, i) => (
                  <li
                    key={i}
                    data-testid={`who-show-${i}`}
                    className="flex items-center gap-3 py-2 border-b border-white/5 last:border-0"
                  >
                    <span
                      className="font-mono text-xs"
                      style={{ color: "var(--blue-bright)" }}
                    >
                      0{i + 1}
                    </span>
                    <span className="text-white/85 text-base lg:text-lg">{s}</span>
                  </li>
                ))}
              </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
